export enum ProfileEnum {
  SUPER_ADMINISTRATOR = 'Super administrador',
}
